import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { createPortal } from "react-dom";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { _Api } from "../api/_call";
import { productmaintablehead } from "../common/Tablehead";
import TableColumnModal from "../common/modules/tableColumn";
import Productfiltermodal from "../common/modules/productfilter";
import ProductImportExportModel from "./productImportExportModel";
import ProductSampleFormatModal from "../common/modules/ProductSampleFormatModal";
import { Pagination } from "../common/Pagination";
import DeleteModal from "../common/modules/deletemodal";
import {
  success,
  error,
  loading,
  Updateloading,
} from "../common/helpers/toastify";



import ProductImageSliderModal from "../common/modules/productImageslider";
import SocialModal from "../common/modules/SocialModal/SocialModal";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useSelector } from "react-redux";
import giftimage from "../../assets/images/icons/Packaging.svg";
import TableLoader from "../../admin/common/TableLoader";
import traceabilityicon from "../../assets/images/TraceItem_diamond.svg";
import carbonNoImage from "../../assets/images/carbon_no-image.svg";
import grid4img from "../../assets/images/grid-4.png";
import grid5img from "../../assets/images/grid-5.png";
import tablerowimg from "../../assets/images/table-row.png";
import blackEmbeddingIcon from "../../assets/images/blackembeddingicon.svg";
import { toast } from "react-toastify";
import axios from "axios";
import { useCatalogEmbeddingSync } from "./useCatalogEmbeddingSync";
import EmbeddingStatusIcon, { hasEmbeddingStatusIcon } from "./EmbeddingStatusIcon";
import "./product.scss";
const MainList = (props) => {
  const { t } = useTranslation();
  const location = useLocation();

  let navigate = useNavigate();
  const [filtername, setFiltername] = useState("");
  const [selecteditem, setSelecteditem] = useState([]);
  const [productlist, setProductlist] = useState([]);
  const [collections, setCollections] = useState(0);
  const [items, setItems] = useState(0);
  const [collectionsFilter, setCollectionsFilter] = useState([]);
  const [itemsFilter, setItemsFilter] = useState([]);
  const [skuFilter, setSKUFilter] = useState([]);
  const [filterApply, setFilterApply] = useState(false);
  const [variant, setVariant] = useState(0);
  const [productcount, setProductcount] = useState(0);
  const [productfilterdetails, setProductfilterdetails] = useState();
  const [newcolumndata, setnewcolumndata] = useState(productmaintablehead);
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [isActive, setIsActive] = useState(false);
  const [limit, setLimits] = useState(100);
  const [imageid, setImageid] = useState();
  const [socialurl, setSocialurl] = useState();
  const [shareloader, setShareloader] = useState(false);
  const [selectAllStatus, setSelectAllStatus] = useState(false);
  const [addparmission, setAddparmission] = useState(0);
  const [editparmission, setEditparmission] = useState(0);
  const [deleteparmission, setDeleteparmission] = useState(0);
  const [printparmission, setPrintparmission] = useState(0);
  const [getSkipNumbers, setSkipNumbers] = useState(0);
  const [falseimage, setFalseimage] = useState(false);
  const [getProductExportList, setGetProductExportList] = useState(false);
  const [shopifyIntegrate, setShopifyIntegrate] = useState();
  const [dropboxIntegrate, setDropboxIntegrate] = useState();
  // const [syncing, setSyncing] = useState(false);
  const [jobId, setJobId] = useState(null);
  const [status, setStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [dropboxSyncing, setDropboxSyncing] = useState(false);
  const dropboxPollRef = useRef(null);
  const [recentJobs, setRecentJobs] = useState([]);
  const [embeddingActive, setEmbeddingActive] = useState(false);

  const viewDropdownRef = useRef(null);
  const viewModeRef = useRef('table');
  const stickyTopRef = useRef(null);
  const tableHeadScrollRef = useRef(null);
  const tableBodyScrollRef = useRef(null);
  const tableHeadTableRef = useRef(null);
  const tableBodyTableRef = useRef(null);
  const tableScrollSyncLock = useRef(false);
  const colDropdownRefItem = useRef(null);
  const colDropdownRefSKU = useRef(null);
  const colDropdownRefCollection = useRef(null);
  const colFilterTriggerRefs = useRef({ item: null, collection: null, sku: null });
  const [openColFilter, setOpenColFilter] = useState(null);
  const [colFilterPortalStyle, setColFilterPortalStyle] = useState({});
  const [viewMode, setViewMode] = useState('table');
  const [viewDropdownOpen, setViewDropdownOpen] = useState(false);
  const stickyThRefs = useRef([]);
  const [stickyLefts, setStickyLefts] = useState([0, 0, 0, 0]);
  const [sortConfig, setSortConfig] = useState({ key: null, dir: 'asc' });
  const [colFilterOptions, setColFilterOptions] = useState({
    item: [],
    collection: [],
    sku: [],
  });
  const [colFilterSearch, setColFilterSearch] = useState({
    item: "",
    collection: "",
    sku: "",
  });

  const sortFieldMap = {
    'Product name': 'name',
    'Product ID': 'ID',
    'SKU': 'SKU',
    'Item': 'item_name',
    'Collection': 'collection_name',
    'Variant': 'VariantsCount',
    'Reorder Point': 'ReorderPoints',
    'Reorder Quantity': 'ReorderQuantitys',
    'Status': 'Status',
  };

  const handleSort = (key) => {
    setSortConfig(prev =>
      prev.key === key ? { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' } : { key, dir: 'asc' }
    );
  };

  const sortIcon = (field) => {
    const isDesc = sortConfig.key === field && sortConfig.dir === 'desc';
    return (
      <div className="up-down-arrow-btn">
        <img
          className="up-down-arrow-img up-down-arrow-img-forward"
          src={base_assets + "images/icons/up-down-arrow.png"}
          alt=""
          style={{ display: isDesc ? 'none' : 'block' }}
        />
        <img
          className="up-down-arrow-img up-down-arrow-img-reverse"
          src={base_assets + "images/icons/up-down-arrow-reverse.png"}
          alt=""
          style={{ display: isDesc ? 'block' : 'none' }}
        />
      </div>
    );
  };

  const sortedList = useMemo(() => {
    if (!sortConfig.key) return productlist;
    return [...productlist].sort((a, b) => {
      const aVal = a[sortConfig.key] ?? '';
      const bVal = b[sortConfig.key] ?? '';
      return sortConfig.dir === 'asc'
        ? String(aVal).localeCompare(String(bVal), undefined, { numeric: true })
        : String(bVal).localeCompare(String(aVal), undefined, { numeric: true });
    });
  }, [productlist, sortConfig]);

  const handleViewModeChange = (mode) => {
    viewModeRef.current = mode;
    setViewMode(mode);
    setSelectAllStatus(false);
    setSelecteditem([]);
  };

  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const integratedApps = useSelector((state) => state.app.integrations);
  const generalsettings = useSelector((state) => state.app.generalsettings);
  const traceabilityEnabled = generalsettings?.data?.generalsetup?.traceability === "1";

  useEffect(() => {
    if (parmissiondatashow?.Product?.View)
      setAddparmission(parmissiondatashow?.Product?.Add);
    setEditparmission(parmissiondatashow?.Product?.Edit);
    setDeleteparmission(parmissiondatashow?.Product?.Delete);
    setPrintparmission(parmissiondatashow?.Product?.Print);
  }, [parmissiondatashow]);
  const [product_value_arr_, setProduct_value_arr] = useState([
    { product_id: "", name: "", varient_type: "" },
  ]);
  let selectAllStatus_arr = [];

  useEffect(() => {
    callcolumns();
  }, []);

  const getshareproductmaster = async () => {
    setShareloader(true);
    try {
      const postdata = {
        search: filtername,
        Item: itemsFilter,
        Collection: collectionsFilter,
        SKU: skuFilter,
      };
      let res = await _Api(
        postdata,
        `api/v1/Inventory/inventory/print/productMaster`,
      );

      if (res.code === 200) {
        setSocialurl(res?.link);
        setShareloader(false);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getprintproductmaster = async () => {
    let GetloadingID = loading();
    try {
      const postdata = {
        search: filtername,
        Item: itemsFilter,
        Collection: collectionsFilter,
        SKU: skuFilter,
      };
      let res = await _Api(
        postdata,
        `api/v1/Inventory/inventory/print/productMaster`,
      );

      if (res.code === 200) {
        setTimeout(() => {
          const exportLinkElement = document.createElement("a");
          exportLinkElement.hidden = true;
          exportLinkElement.download = res?.name ? res?.name : "report.pdf";
          exportLinkElement.href = res?.link;
          exportLinkElement.text = "downloading...";
          exportLinkElement.setAttribute("target", "_blank");
          document.body.appendChild(exportLinkElement);
          exportLinkElement.click();
          exportLinkElement.remove();
          Updateloading(t, GetloadingID, t("download successfully"));
        }, 50);
        setSocialurl(res?.link);
      } else {
        Updateloading(
          t,
          GetloadingID,
          res?.message ? res?.message : res?.errors,
          "error",
        );
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, err, t("error"));
    }
  };
  const handleFilter = (cls = false) => {
    if (cls) {
      Getproduct(currentPage, limit, "");
    } else {
      Getproduct(currentPage, limit, filtername);
    }
    setstate({ ...state, currentPage: 1 });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleFilter();
    }
  };
  const handleButtonClickClear = () => {
    setFiltername("");
    handleFilter(true);
  };

  const handleButtonClick = () => {
    handleFilter();
  };

  const getlimit = (limit) => {
    setLimits(limit);
    Getproduct(1, limit);
    setstate({ ...state, currentPage: 1 });
  };
  const [state, setstate] = useState({
    totalPages: 20,
    currentPage: 1,
  });

  const { totalPages, currentPage } = state;
  const handlePaginations = (current) => {
    setstate({ ...state, currentPage: current });
    Getproduct(current, "");
  };
  const callcolumns = async () => {
    try {
      const postdata = {
        name: "tbl_product_main",
      };
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`,
      );
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getCardCounts = useCallback(async () => {
    try {
      const postdata = {
        search: filtername,
        Item: itemsFilter,
        Collection: collectionsFilter,
        SKU: skuFilter,
      };
      let resproduct = await _Api(
        postdata,
        `api/v1/App/product/getproductListCount`,
      );
      if (resproduct?.code === 200) {
        var resproduct_data = resproduct?.data;
        setCollections(resproduct_data?.Collection);
        setItems(resproduct_data?.Item);
        setVariant(resproduct_data?.variant);
        setProductcount(resproduct_data?.sku);
      } else {
      }
    } catch (err) {
      console.log(err, "err");
    }
  }, [filtername, itemsFilter, collectionsFilter, skuFilter]);
  const Getproduct = async (current, limits, search, falseimageOverride, filterOverride) => {
    setFilterApply(false);
    setIsActive(true);
    try {
      var skipNumber = current ? (current - 1) * limit : 0;
      const postdata = {
        search: search ? search : "",
        limit: limits ? limits : limit,
        skip: search ? 0 : skipNumber,
        Item: filterOverride?.Item ?? itemsFilter,
        Collection: filterOverride?.Collection ?? collectionsFilter,
        SKU: filterOverride?.SKU ?? skuFilter,
        falseimage: falseimageOverride !== undefined ? falseimageOverride : falseimage,
      };
      let resproduct = await _Api(
        postdata,
        `api/v1/App/product/getproductList`,
      );
      if (resproduct?.code === 200) {
        setEmbeddingActive(Boolean(resproduct?.embedding_active));
        setSkipNumbers(skipNumber);
        // Names stay full length: the table cell truncates them with CSS and shows the full name on hover.
        let data = [...resproduct?.data];
        // setProductlist(resproduct?.data);
        setProductlist(data);
        setIsActive(false);
        setstate({
          ...state,
          totalPages: Math.ceil(resproduct?.count / postdata.limit),
          currentPage: current ? current : 1,
        });
      } else {
        setIsActive(false);
      }
    } catch (err) {
      console.log(err, "err");
      setIsActive(false);
    }
  };

  const refreshProductList = useCallback(() => {
    Getproduct(currentPage, limit, filtername);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, limit, filtername]);

  const {
    isEmbeddingSubmitting,
    startSyncAll,
    startSyncProducts,
  } = useCatalogEmbeddingSync({
    onComplete: refreshProductList,
    t,
  });

  const handleEmbeddingClick = () => {
    if (selecteditem.length > 0) {
      const idsToSync = selecteditem.filter((id) => {
        const product = productlist.find((p) => p._id === id);
        return product?.embedding_status !== "synced";
      });

      if (!idsToSync.length) {
        toast.info(t("These products are already synced"));
        return;
      }

      startSyncProducts(idsToSync);
      return;
    }
    startSyncAll();
  };

  useEffect(() => {
    if (location?.state?.currentPage) {
      Getproduct(location?.state?.currentPage, "");
    } else {
      Getproduct();
    }
    getColFilterOptions();
    getCardCounts();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (filterApply) {
      Getproduct();
    }
    // eslint-disable-next-line
  }, [filterApply]);
  const deleteIcon = (event) => {
    if (event.target.checked) {
      const mainselected = [...selecteditem, event.target.value];
      setSelecteditem(mainselected);
    } else {
      const result = selecteditem.filter((element) => {
        return element !== event.target.value;
      });
      setSelecteditem(result);
    }
  };
  const handler_delete = async () => {
    try {
      const postdata = {
        id: selecteditem,
      };
      let resproductdelete = await _Api(
        postdata,
        `api/v1/App/product/delproduct`,
      );
      if (resproductdelete?.code === 200) {
        setSelecteditem([]);
        let checkboxs = document.querySelectorAll(".productList_checkBox");
        for (let i = 0; i < checkboxs.length; i++) {
          checkboxs[i].checked = false;
        }
        success(t(resproductdelete?.message));
        Getproduct();
      } else {
        error(t(resproductdelete?.message));
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const filteringproducts = async () => {
    try {
      const postdata = {};
      let resproductfilter = await _Api(
        postdata,
        `api/v1/App/product/getMasterFliters`,
      );
      if (resproductfilter?.code === 200) {
        setProductfilterdetails(resproductfilter?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const getColFilterOptions = async () => {
    try {
      let res = await _Api({}, `api/v1/App/product/getMasterFliters`);
      if (res?.code === 200) {
        setColFilterOptions({
          item: (res?.data?.Item || []).map((o) => ({
            _id: String(o?.id),
            name: o?.name,
          })),
          collection: (res?.data?.Collection || []).map((o) => ({
            _id: String(o?.id),
            name: o?.name,
          })),
          sku: (res?.data?.SKU || []).map((o) => ({
            _id: String(o?.id ?? o?.name),
            name: o?.name ?? o?.id,
          })),
        });
        setProductfilterdetails(res?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const getActiveFilterValues = (filterKey) => {
    if (filterKey === "item") return itemsFilter;
    if (filterKey === "collection") return collectionsFilter;
    if (filterKey === "sku") return skuFilter;
    return [];
  };

  const setActiveFilterValues = (filterKey, values) => {
    if (filterKey === "item") setItemsFilter(values);
    else if (filterKey === "collection") setCollectionsFilter(values);
    else if (filterKey === "sku") setSKUFilter(values);
  };

  const handleColFilterItemChange = (event, value, filterKey) => {
    const prev = getActiveFilterValues(filterKey);
    setActiveFilterValues(
      filterKey,
      event.target.checked
        ? [...prev, value]
        : prev.filter((v) => v !== value),
    );
  };

  const handleColFilterSelectAll = (event, filterKey) => {
    const allValues = (colFilterOptions?.[filterKey] || []).map((o) => o._id);
    setActiveFilterValues(filterKey, event.target.checked ? allValues : []);
  };

  const applyColFilter = (filterKey) => {
    setstate((prev) => ({ ...prev, currentPage: 1 }));
    Getproduct(1, limit, filtername, undefined, {
      Item: getActiveFilterValues("item"),
      Collection: getActiveFilterValues("collection"),
      SKU: getActiveFilterValues("sku"),
    });
    setOpenColFilter(null);
  };

  const colFilterSortFieldMap = {
    item: "item_name",
    collection: "collection_name",
    sku: "SKU",
  };

  const handleColFilterSort = (filterKey, dir) => {
    const sortKey = colFilterSortFieldMap[filterKey];
    if (!sortKey) return;
    setSortConfig({ key: sortKey, dir });
    setOpenColFilter(null);
  };

  const updateColFilterPortalPosition = (filterKey) => {
    const trigger = colFilterTriggerRefs.current[filterKey];
    if (!trigger) return;
    const rect = trigger.getBoundingClientRect();
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const menuWidth = 286;
    let left = rect.left;
    if (left + menuWidth + 8 > viewportWidth) {
      left = Math.max(8, viewportWidth - menuWidth - 8);
    }
    setColFilterPortalStyle({
      position: "fixed",
      top: rect.bottom + 6,
      left,
      width: menuWidth,
      zIndex: 3000,
    });
  };

  useEffect(() => {
    if (!openColFilter) return undefined;
    updateColFilterPortalPosition(openColFilter);
    const handleReposition = () => updateColFilterPortalPosition(openColFilter);
    const handleOutsideClick = (event) => {
      const trigger = colFilterTriggerRefs.current[openColFilter];
      const menu = openColFilter === "item"
        ? colDropdownRefItem.current
        : openColFilter === "collection"? colDropdownRefCollection.current:colDropdownRefSKU.current;
      if (trigger?.contains(event.target) || menu?.contains(event.target)) {
        return;
      }
      setOpenColFilter(null);
    };
    window.addEventListener("resize", handleReposition);
    window.addEventListener("scroll", handleReposition, true);
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      window.removeEventListener("resize", handleReposition);
      window.removeEventListener("scroll", handleReposition, true);
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [openColFilter]);

  const renderColFilterDropdown = (filterKey, dropdownRef) => {
    const options = colFilterOptions?.[filterKey] || [];
    const checkedVals = getActiveFilterValues(filterKey) || [];
    const searchTerm = colFilterSearch[filterKey] || "";
    const filteredOptions = searchTerm
      ? options.filter((o) =>
          o?.name?.toLowerCase().includes(searchTerm.toLowerCase()),
        )
      : options;
    const isOpen = openColFilter === filterKey;

    const menuContent = (
      <div
        className="dropdown-menu show com-custom-table-tag-filter-menu dtbs-filter-dropdown-menu dtbs-filter-portal-menu p-0 border-0 overflow-hidden"
        style={colFilterPortalStyle}
        ref={dropdownRef}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="asc-des-order">
          <div
            className="asc-des-order-single cursor-pointer"
            onClick={() => handleColFilterSort(filterKey, "asc")}
          >
            <img
              src={base_assets + "images/icons/arrow-sort-up.png"}
              alt=""
            />
            {t("Sort Ascending")}
          </div>
          <div
            className="asc-des-order-single cursor-pointer"
            onClick={() => handleColFilterSort(filterKey, "desc")}
          >
            <img
              src={base_assets + "images/icons/arrow-sort-down.png"}
              alt=""
            />
            {t("Sort Descending")}
          </div>
        </div>
        <div className="com-custom-table-tag-filter-menu-search">
          <div className="com-custom-table-tag-filter-menu-search-inner d-flex align-items-center">
            <img src={base_assets + "images/icons/search-icon.png"} alt="" />
            <input
              className="border-0"
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) =>
                setColFilterSearch((prev) => ({
                  ...prev,
                  [filterKey]: e.target.value,
                }))
              }
            />
          </div>
        </div>
        <div className="com-custom-table-tag-filter-menu-select">
          <div className="com-custom-table-tag-filter-menu-select-bar d-flex align-items-center justify-content-between">
            <div>
              <input
                className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer"
                type="checkbox"
                id={`colfilter-all-${filterKey}`}
                onChange={(e) => handleColFilterSelectAll(e, filterKey)}
                checked={
                  options.length > 0 && checkedVals.length === options.length
                }
              />
              <label
                className="form-check-label cursor-pointer fw-semibold"
                htmlFor={`colfilter-all-${filterKey}`}
              >
                {t("Select All")}
              </label>
            </div>
            <label>
              {checkedVals.length}/{options.length} {t("Selected")}
            </label>
          </div>
          <ul className="com-custom-table-tag-filter-menu-select-list list-unstyled mt-3 ps-4">
            {filteredOptions.map((opt, idx) => {
              const val = opt._id;
              const optId = `colfilter-${filterKey}-${idx}`;
              return (
                <li
                  className="com-custom-table-tag-filter-menu-select-list-single"
                  key={optId}
                >
                  <input
                    className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer"
                    type="checkbox"
                    id={optId}
                    checked={checkedVals.includes(val)}
                    onChange={(e) =>
                      handleColFilterItemChange(e, val, filterKey)
                    }
                  />
                  <label
                    className="form-check-label cursor-pointer"
                    htmlFor={optId}
                  >
                    {opt?.name}
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="com-custom-table-tag-filter-menu-btn-grp text-center d-flex align-items-center gap-2">
          <button
            className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 bg-transparent fw-semibold graythemecolor"
            onClick={() => {
              setActiveFilterValues(filterKey, []);
              setColFilterSearch((prev) => ({ ...prev, [filterKey]: "" }));
            }}
          >
            {t("Clear")}
          </button>
          <button
            className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 main-green-bg text-white fw-semibold"
            onClick={() => applyColFilter(filterKey)}
          >
            {t("Apply")}
          </button>
        </div>
      </div>
    );

    return (
      <div
        className="d-inline-block com-custom-table-tag-filter dtbs-filter-dropdown"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          ref={(el) => {
            colFilterTriggerRefs.current[filterKey] = el;
          }}
          className="after-none bg-transparent border-0 p-0"
          type="button"
          aria-expanded={isOpen}
          onClick={() => {
            setOpenColFilter((prev) => {
              const next = prev === filterKey ? null : filterKey;
              if (next) {
                // Position immediately so first paint isn't at 0,0
                const trigger = colFilterTriggerRefs.current[filterKey];
                if (trigger) {
                  const rect = trigger.getBoundingClientRect();
                  const viewportWidth =
                    window.innerWidth || document.documentElement.clientWidth;
                  const menuWidth = 286;
                  let left = rect.left;
                  if (left + menuWidth + 8 > viewportWidth) {
                    left = Math.max(8, viewportWidth - menuWidth - 8);
                  }
                  setColFilterPortalStyle({
                    position: "fixed",
                    top: rect.bottom + 6,
                    left,
                    width: menuWidth,
                    zIndex: 3000,
                  });
                }
              }
              return next;
            });
          }}
        >
          <img
            className="ms-2 com-custom-table-tag-filter-img"
            src={base_assets + "images/icons/table-filter-icon.png"}
            alt=""
          />
        </button>
        {isOpen && createPortal(menuContent, document.body)}
      </div>
    );
  };
  const callimportimage = () => {
    navigate("/app/product/importproductimage");
  };
  const setProductValue = (product_id, name, varient_type) => {
    setProduct_value_arr([
      { product_id: product_id, name: name, varient_type: varient_type },
    ]);
  };

  useEffect(() => {
    var allCheckbox = document.querySelectorAll(".productList_checkBox");
    if (selectAllStatus === true) {
      allCheckbox.forEach(function (checkBox_selectAble) {
        checkBox_selectAble.checked = true;
        selectAllStatus_arr.push(checkBox_selectAble.value);
      });
      let arrya = [];
      for (let i = 0; i < allCheckbox.length; i++) {
        if (allCheckbox[i].checked) {
          let product_id = allCheckbox[i].getAttribute("data-id");
          arrya.push(product_id);
        }
      }
      setSelecteditem(arrya);
    } else {
      allCheckbox.forEach(function (checkBox_selectAble) {
        checkBox_selectAble.checked = false;
      });
      setSelecteditem([]);
    }
    setSelecteditem(selectAllStatus_arr);
    // eslint-disable-next-line
  }, [selectAllStatus]);

  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 },
  ];

  useEffect(() => {
    const shopifyData = integratedApps?.find((app) => app?.slag === "shopify");
    setShopifyIntegrate(shopifyData?.status);
    const dropboxData = integratedApps?.find(
      (app) => String(app?.slag || app?.name || "").toLowerCase() === "dropbox"
    );
    setDropboxIntegrate(Number(dropboxData?.status) === 1);
  }, [integratedApps]);

  // const synShopify = async () => {
  //   try {
  //     if (syncing) return;
  //     setSyncing(true);
  //     const postData = {};
  //     const res = await _Api(postData, `api/v1/App/shopify/syncShopify`);
  //     if (res.success === true) {
  //       toast.success(res?.message);
  //       setSyncing(false);
  //     } else {
  //       toast.error(res?.message);
  //       setSyncing(false);
  //     }
  //     console.log("✅ Shopify Sync Response:", res);
  //   } catch (err) {
  //     //  toast.error(err?.message)
  //     console.error("❌ Shopify sync error:", err);
  //     setSyncing(false);
  //   } finally {
  //     setSyncing(false);
  //   }
  // };

  const stopDropboxPoll = () => {
    if (dropboxPollRef.current) {
      clearInterval(dropboxPollRef.current);
      dropboxPollRef.current = null;
    }
  };

  const syncDropboxImages = async () => {
    if (dropboxSyncing) return;
    setDropboxSyncing(true);
    const loadingId = loading();
    try {
      const res = await _Api(
        { only_missing: true },
        `api/v1/App/product/syncDropboxImages`,
      );
      if (res?.code !== 200 && res?.code !== 409) {
        setDropboxSyncing(false);
        Updateloading(t, loadingId, res?.message || t("Dropbox image sync failed"), "error");
        return;
      }
      Updateloading(t, loadingId, res?.message || t("Dropbox image sync started"));
      stopDropboxPoll();
      dropboxPollRef.current = setInterval(async () => {
        try {
          const statusRes = await _Api({}, `api/v1/App/product/syncDropboxImagesStatus`);
          if (statusRes?.status === "running") return;
          stopDropboxPoll();
          setDropboxSyncing(false);
          if (statusRes?.status === "done") {
            success(statusRes?.message || t("Dropbox images synced"));
            Getproduct(currentPage, limit, filtername, falseimage);
          } else {
            error(statusRes?.message || t("Dropbox image sync failed"));
          }
        } catch (err) {
          stopDropboxPoll();
          setDropboxSyncing(false);
          error(t("Dropbox image sync failed"));
        }
      }, 3000);
    } catch (err) {
      setDropboxSyncing(false);
      Updateloading(t, loadingId, err?.message || t("Dropbox image sync failed"), "error");
    }
  };


  useEffect(() => {
    return () => {
      stopDropboxPoll();
    };
  }, []);

  const synShopify = async () => {
    setIsLoading(true);
    try {
      const postData = { sync_type: "full" }; // Can be: full, products_only, variants_only, inventory_only
      const response = await _Api(postData, `api/v1/App/shopify/syncShopify`);

      if (response?.success === true) {
        setJobId(response.job_id);
        console.log("✅ Sync started:", response);
        toast.success("Sync started");
      }
    } catch (err) {
      console.error("❌ Failed to start sync:", err);
      toast.error(err.response?.message || "Failed to start sync");
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch job status
  const fetchStatus = useCallback(async (id) => {
    try {
      const response = await _Api({}, `api/v1/App/shopify/sync-status/${id}`);
      setStatus(response.job);
    } catch (err) {
      console.error("❌ Failed to get status:", err);
      toast.error(err.response?.message || "Failed to get sync status");
    }
  }, []);

  // Fetch recent jobs
  const fetchRecentJobs = async () => {
    try {
      const response = await _Api({}, "api/v1/App/shopify/sync-jobs");
      setRecentJobs(response?.jobs || []);
    } catch (err) {
      console.error("❌ Failed to get recent jobs:", err);
    }
  };

  useEffect(() => {
    if (!jobId) return;

    const interval = setInterval(() => {
      fetchStatus(jobId);
    }, 3000);

    fetchStatus(jobId);

    return () => clearInterval(interval);
  }, [jobId, fetchStatus]);

  useEffect(() => {
    if (
      status &&
      ["completed", "failed", "cancelled"].includes(status.status)
    ) {
      fetchRecentJobs();
    }
  }, [status]);

  // Load recent jobs on mount
  useEffect(() => {
    fetchRecentJobs();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (viewDropdownRef.current && !viewDropdownRef.current.contains(e.target)) {
        setViewDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const computeStickyLefts = () => {
      let acc = 0;
      const lefts = stickyThRefs.current.map((th) => {
        const left = acc;
        if (th) acc += th.offsetWidth;
        return left;
      });
      setStickyLefts(lefts);
    };
    computeStickyLefts();
    window.addEventListener('resize', computeStickyLefts);
    return () => window.removeEventListener('resize', computeStickyLefts);
  }, [productlist, newcolumndata, embeddingActive, viewMode]);

  useEffect(() => {
    const el = stickyTopRef.current;
    if (!el) return undefined;
    const page = el.closest(".product-page-wrap");
    const apply = () => {
      if (!page) return;
      page.style.setProperty(
        "--product-sticky-block-height",
        `${el.offsetHeight}px`,
      );
    };
    apply();
    const observer = new ResizeObserver(apply);
    observer.observe(el);
    window.addEventListener("resize", apply);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", apply);
    };
  }, []);

  const syncProductTableScroll = (source) => {
    if (tableScrollSyncLock.current) return;
    const head = tableHeadScrollRef.current;
    const body = tableBodyScrollRef.current;
    if (!head || !body) return;
    tableScrollSyncLock.current = true;
    if (source === "head") {
      body.scrollLeft = head.scrollLeft;
    } else {
      head.scrollLeft = body.scrollLeft;
    }
    requestAnimationFrame(() => {
      tableScrollSyncLock.current = false;
    });
  };

  useEffect(() => {
    if (viewMode !== "table") return undefined;
    let frame = 0;
    const syncProductTableWidths = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const headTable = tableHeadTableRef.current;
        const bodyTable = tableBodyTableRef.current;
        if (!headTable || !bodyTable) return;

        const headThs = headTable.querySelectorAll("thead th");
        const bodyRow = bodyTable.querySelector("tbody tr");
        const count = headThs.length;
        if (!count) return;

        headTable.style.width = "max-content";
        bodyTable.style.width = "max-content";
        headTable.style.tableLayout = "auto";
        bodyTable.style.tableLayout = "auto";
        headThs.forEach((th) => {
          th.style.width = "";
          th.style.minWidth = "";
          th.style.maxWidth = "";
        });
        bodyTable.querySelectorAll("td, th").forEach((cell) => {
          cell.style.width = "";
          cell.style.minWidth = "";
          cell.style.maxWidth = "";
        });

        const widths = [];
        for (let i = 0; i < count; i += 1) {
          const hw = headThs[i].getBoundingClientRect().width;
          const bw = bodyRow?.children[i]?.getBoundingClientRect().width || 0;
          widths.push(Math.ceil(Math.max(hw, bw, 40)));
        }
        const total = widths.reduce((sum, w) => sum + w, 0);
        headTable.style.tableLayout = "fixed";
        bodyTable.style.tableLayout = "fixed";
        headTable.style.width = `${total}px`;
        bodyTable.style.width = `${total}px`;

        for (let i = 0; i < count; i += 1) {
          const widthPx = `${widths[i]}px`;
          headThs[i].style.width = widthPx;
          headThs[i].style.minWidth = widthPx;
          headThs[i].style.maxWidth = widthPx;
          bodyTable
            .querySelectorAll(`tr > :nth-child(${i + 1})`)
            .forEach((cell) => {
              cell.style.width = widthPx;
              cell.style.minWidth = widthPx;
              cell.style.maxWidth = widthPx;
            });
        }

        let acc = 0;
        const lefts = stickyThRefs.current.map((th) => {
          const left = acc;
          if (th) acc += th.offsetWidth;
          return left;
        });
        setStickyLefts(lefts);
      });
    };

    syncProductTableWidths();
    window.addEventListener("resize", syncProductTableWidths);
    const observer = new ResizeObserver(syncProductTableWidths);
    if (tableHeadScrollRef.current) observer.observe(tableHeadScrollRef.current);
    if (tableBodyScrollRef.current) observer.observe(tableBodyScrollRef.current);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", syncProductTableWidths);
      observer.disconnect();
    };
  }, [sortedList, newcolumndata, isActive, embeddingActive, viewMode]);

  return (
    <React.Fragment>
      <div className="main-body product-page-wrap product-tab-page-padding-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12" style={{display:'flex',flexWrap:'wrap'}}>
              <div className="sticky-top-product-page" ref={stickyTopRef}>
              <h1 className="main-body-heading">{t("Products")}</h1>
              <div className="main-body-top-inventory">
                <div className="main-body-top-inventory-status">
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + "images/icons/sku.png"}
                        className="inventory-img"
                        alt="sku"
                      />
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t("SKU")}</p>
                      <h2 className="inventory-value sku">{productcount}</h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + "images/icons/pro-cart.png"}
                        className="inventory-img"
                        alt="sku"
                      />
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t("Item")}</p>
                      <h2 className="inventory-value item">{items}</h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + "images/icons/customer-pro.png"}
                        className="inventory-img"
                        alt="value"
                      />
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t("Collection")}</p>
                      <h2 className="inventory-value value">{collections}</h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + "images/icons/Variants.png"}
                        className="inventory-img"
                        alt="free-stock"
                      />
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t("Variants")}</p>
                      <h2 className="inventory-value variant">{variant}</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="main-body-top-status-bar">
                <Select
                  className="limit-select short"
                  options={selectOptions}
                  value={{ label: limit, value: limit }}
                  onChange={(e) => {
                    getlimit(e.value);
                  }}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                />
                <div className="main-body-top-status-bar-filter">
                  <button
                    className="main-body-top-status-bar-filter-icon"
                    data-bs-toggle="modal"
                    data-bs-target="#productfiltermodal"
                    onClick={filteringproducts}
                  >
                    <img
                      src={base_assets + "images/icons/search-outline.png"}
                      alt=""
                    />
                  </button>
                  <input
                    type="text"
                    value={filtername}
                    className="main-body-top-status-bar-filter-input"
                    placeholder={t("Product Name, SKU...")}
                    onKeyPress={handleKeyPress}
                    onChange={(e) => setFiltername(e.target.value)}
                  />
                  {filtername ? (
                    <img
                      className="main-body-top-status-bar-filter-clear"
                      src={base_assets + "images/icons/False.png"}
                      onClick={handleButtonClickClear}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                  <button
                    onClick={handleButtonClick}
                    className="main-body-top-status-bar-filter-search"
                  >
                    <i className="fa fa-search" aria-hidden="true" />
                  </button>
                </div>
                <div className="main-body-top-status-bar-multi-date-picker">
                  <button
                    className={
                      deleteparmission
                        ? "print-export-dropdown-selected-icon"
                        : "d-none"
                    }
                  >
                    <img
                      className={
                        selecteditem.length > 0
                          ? "deletebtn d-block"
                          : "deletebtn d-none"
                      }
                      src={base_assets + "images/icons/delete-icon.png"}
                      alt=""
                      data-bs-toggle="modal"
                      data-bs-target="#delete-listedModal"
                    />
                  </button>

                  <Link
                    to={
                      selecteditem.length === 1
                        ? "/app/product/clone/" + selecteditem[0]
                        : "deletebtn d-none"
                    }
                  >
                    <img
                      className={
                        selecteditem.length === 1
                          ? "deletebtn d-block"
                          : "deletebtn d-none"
                      }
                      src={base_assets + "images/icons/clone.svg"}
                      alt=""
                    />
                  </Link>
                  {embeddingActive && (
                    <div
                      className={`tooltip-area-up catalog-embedding-toolbar-btn${
                        isEmbeddingSubmitting ? " catalog-embedding-toolbar-btn--disabled" : ""
                      }`}
                      onClick={isEmbeddingSubmitting ? undefined : handleEmbeddingClick}
                    >
                      <img
                        src={blackEmbeddingIcon}
                        alt=""
                      />
                      <span
                        className="tooltip-area-up-text"
                        style={{
                          backgroundColor: "#5CC7C1",
                          marginBottom: "5px",
                        }}
                      >
                        {t("Embedding")}
                      </span>
                    </div>
                  )}
                  <button className="print-export-dropdown-selected-icon d-none">
                    <img
                      src={base_assets + "images/icons/printer-icon.png"}
                      alt=""
                    />
                  </button>
                  <div
                    className={addparmission ? "product-main-create" : "d-none"}
                  >
                    <div className="tooltip-area-up">
                    <button
                      className={`pro-img me-0 import-export-btn ${falseimage ? 'active' : ''}`}
                      style={falseimage ? { backgroundColor: '#e0e0e0', border: '1px solid #b0b0b0' } : {}}
                      onClick={() => {
                        const next = !falseimage;
                        setFalseimage(next);
                        Getproduct(currentPage, limit, filtername, next);
                      }}
                    >
                      <img
                        className="m-auto d-block"
                        src={carbonNoImage}
                        alt="no-image"
                      />
                    </button>
                      <span
                        className="tooltip-area-up-text"
                        style={{ backgroundColor: "#5CC7C1", marginBottom: "5px" }}
                      >
                        {t("No Image Product")}
                      </span>
                    </div>
                     <div ref={viewDropdownRef} style={{ position: 'relative',display:"flex",justifyContent:"center",alignItems:"center" }}>
                        <div className="tooltip-area-up">
                        <button
                          type="button"
                          onClick={() => setViewDropdownOpen(o => !o)}
                          style={{   background: 'transparent', cursor: 'pointer', lineHeight: 1, display: 'flex', alignItems: 'center',border: 'none' }}
                        >
                          {viewMode === 'grid5' && <img src={grid5img} alt="5 columns"  />}
                          {viewMode === 'grid4' && <img src={grid4img} alt="4 columns"  />}
                          {viewMode === 'table' && <img src={tablerowimg} alt="table"  />}
                        </button>
                        <span
                          className="tooltip-area-up-text"
                          style={{ backgroundColor: "#5CC7C1", marginBottom: "5px" }}
                        >
                          {viewMode === 'grid5' ? t("5 columns") : viewMode === 'grid4' ? t("4 columns") : t("Table view")}
                        </span>
                        </div>
                        {viewDropdownOpen && (
                          <div style={{ position: 'absolute', top: 'calc(100% + 4px)', right: 0, background: '#fff', border: '1px solid #E5E5E5', borderRadius: '6px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', padding: '6px', display: 'flex', gap: '4px', zIndex: 999 }}>
                            <button
                              type="button"
                              className="tooltip-area-up"
                              onClick={() => { handleViewModeChange('grid5'); setViewDropdownOpen(false); }}
                              style={{ padding: '6px 8px', border: 'none', borderRadius: '4px', background: viewMode === 'grid5' ? '#5cc7c1' : 'transparent', cursor: 'pointer', lineHeight: 1, display: 'flex', alignItems: 'center' }}
                            >
                              <img src={grid5img} alt="5 columns"  />
                              <span className="tooltip-area-up-text" style={{ backgroundColor: "#5CC7C1" }}>{t("5 columns")}</span>
                            </button>
                            <button
                              type="button"
                              className="tooltip-area-up"
                              onClick={() => { handleViewModeChange('grid4'); setViewDropdownOpen(false); }}
                              style={{ padding: '6px 8px', border: 'none', borderRadius: '4px', background: viewMode === 'grid4' ? '#5cc7c1' : 'transparent', cursor: 'pointer', lineHeight: 1, display: 'flex', alignItems: 'center' }}
                            >
                              <img src={grid4img} alt="4 columns"  />
                              <span className="tooltip-area-up-text" style={{ backgroundColor: "#5CC7C1" }}>{t("4 columns")}</span>
                            </button>
                            <button
                              type="button"
                              className="tooltip-area-up"
                              onClick={() => { handleViewModeChange('table'); setViewDropdownOpen(false); }}
                              style={{ padding: '6px 8px', border: 'none', borderRadius: '4px', background: viewMode === 'table' ? '#5cc7c1' : 'transparent', cursor: 'pointer', lineHeight: 1, display: 'flex', alignItems: 'center' }}
                            >
                              <img src={tablerowimg} alt="table"  />
                              <span className="tooltip-area-up-text" style={{ backgroundColor: "#5CC7C1" }}>{t("Table view")}</span>
                            </button>
                          </div>
                        )}
                      </div>
                    <div className="tooltip-area-up">
                    <button
                      data-bs-toggle="modal"
                      data-bs-target="#productImportExportModel_data"
                      className="pro-img me-0 import-export-btn"
                      onClick={() => setGetProductExportList(true)}
                    >
                      <img
                        className="m-auto d-block"
                        src={base_assets + "images/icons/exit_icon.png"}
                        alt=""
                      />
                    </button>
                      <span
                        className="tooltip-area-up-text"
                        style={{ backgroundColor: "#5CC7C1", marginBottom: "5px" }}
                      >
                        {t("Import")}
                      </span>
                    </div>
                    <button onClick={callimportimage} className="pro-img">
                      <img
                        className=""
                        src={base_assets + "images/icons/image.png"}
                        alt=""
                      />
                      {t("Product Image")}
                    </button>
                    {dropboxIntegrate ? (
                    <div
                      className="tooltip-area-up"
                      onClick={dropboxSyncing ? undefined : syncDropboxImages}
                      style={{ cursor: dropboxSyncing ? "not-allowed" : "pointer" }}
                    >
                      <button
                        type="button"
                        className="pro-img"
                        disabled={dropboxSyncing}
                        style={{ pointerEvents: "none" }}
                      >
                        <i
                          className="fa fa-dropbox"
                          aria-hidden="true"
                          style={{ fontSize: "18px", margin: 0, color: "#0061ff" }}
                        />
                      </button>
                      <span
                        className="tooltip-area-up-text"
                        style={{
                          backgroundColor: "#5CC7C1",
                          marginBottom: "5px",
                          whiteSpace: "normal",
                          width: "240px",
                        }}
                      >
                        {dropboxSyncing
                          ? t("Syncing images")
                          : t("Sync images up to 20,000 JPG, JPEG, PNG, or WebP images (max. 300 KB each)")}
                      </span>
                    </div>
                    ) : null}
                    {productlist?.length > 0 && shopifyIntegrate ? (
                      <div
                        className="tooltip-area-up"
                        onClick={!isLoading ? synShopify : undefined}
                        style={{
                          cursor: !isLoading ? "pointer" : "not-allowed",
                        }}
                      >
                        <img
                          className=""
                          style={{
                            width: "36px",
                            height: "32px",
                          }}
                          // src={base_assets + "images/icons/shopify.png"}
                          src="/assets/v2/images/icons/shopify.png"
                          alt=""
                        />
                        <span
                          className="tooltip-area-up-text"
                          style={{
                            backgroundColor: "#5CC7C1",
                            marginBottom: "5px",
                          }}
                        >
                          {t("Sync Shopify")}
                        </span>
                      </div>
                    ) : null}
                    <Link
                      to="/app/product/add-new"
                      state={{ product_value_arr: product_value_arr_ }}
                      className="text-decoration-none"
                    >
                      <button className="create">
                        <img
                          className=""
                          src={
                            base_assets + "images/icons/plus-circle-white.png"
                          }
                          alt=""
                        />
                        {t("Create")}
                      </button>
                    </Link>
                  </div>
                 
                  <div className="main-body-top-status-bar-print-export-dropdown dropdown">
                    <button
                      className="btn dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        src={base_assets + "images/icons/ellipsis-circular.png"}
                        alt=""
                      />
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li
                        className={
                          printparmission
                            ? "dropdown-item print-dropdown-item"
                            : "d-none"
                        }
                        onClick={(e) => {
                          getprintproductmaster(e.target.value);
                        }}
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + "images/icons/printer-icon.png"}
                            alt=""
                          />
                        </div>
                        <span>{t("print")}</span>
                      </li>

                      <li
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#socialModal"
                        onClick={() => getshareproductmaster()}
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + "images/icons/share-icon.png"}
                            alt=""
                          />
                        </div>
                        <span>{t("share")}</span>
                      </li>
                      <li
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#productSampleFormatModal"
                      >
                        <div className="dropdown-item-img">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 1.333v9.334M8 10.667L5.333 8M8 10.667L10.667 8M2.667 14h10.666" stroke="#A4A4A4" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                        <span>{t("Sample")}</span>
                      </li>
                      {/* <li
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#columnModal"
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + "images/icons/column-icon.png"}
                            alt=""
                          />
                        </div>
                        <span>{t("column")}</span>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
              </div>
              <div
                className="main-body-main-table-wrap position-relative"
                style={{
                  maxWidth: "100%",
                  width: "100%",
                  overflow: viewMode === "table" ? "visible" : "visible",
                }}
              >
                {viewMode !== 'table' && (
                  <div className={`row g-3 ${viewMode === 'grid5' ? 'row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5' : 'row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4'}`}>
                    {!isActive && productlist?.length ? productlist.map((result, key) => (
                      <div className="col" key={key}>
                        <div style={{ position: 'relative', background: '#FFFFFF', boxShadow: '0px 1px 2px rgba(0,0,0,0.05)', borderRadius: '4px' }}>
                          <div style={{ position: 'relative', width: '100%', paddingBottom: '78%', background: '#D9D9D9', overflow: 'hidden', borderRadius: '4px 4px 0 0' }}>
                            <img
                              src={result?.main_image || ''}
                              alt=""
                              style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', cursor: 'pointer' }}
                              onError={(e) => { e.target.onerror = null; e.target.src = 'https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png'; }}
                              onClick={() => setImageid(result?._id)}
                              data-bs-toggle="modal"
                              data-bs-target="#ProductViewModal"
                            />
                            <div style={{ position: 'absolute', left: '16px', top: '13px', zIndex: 2 }} className="com-check">
                              <input
                                className="gisClassTh productList_checkBox"
                                value={result?._id}
                                data-id={result?._id}
                                type="checkbox"
                                id={result?._id}
                                onClick={deleteIcon}
                                data-name={result?.name || ''}
                                data-variant={result?.product_variants_enable}
                                name="master_product_checkbox"
                              />
                              <label htmlFor={result?._id} className="com-check-label" />
                            </div>
                          </div>
                          <div style={{ padding: '14px 16px' }}>
                            <Link
                              className="text-decoration-none"
                              to={editparmission ? '/app/product/add-new/' + result?._id : ''}
                              state={{ product_value_arr: [{ product_id: result?._id, name: result?.name, varient_type: result?.product_variants_enable }], currentPage: currentPage || 0 }}
                              onClick={() => setProductValue(result?._id, result?.name, result?.product_variants_enable)}
                            >
                              <p style={{ margin: 0, fontFamily: 'Segoe UI, sans-serif', fontWeight: 400, fontSize: '16px', color: '#A4A4A4', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{result?.name || ''}</p>
                            </Link>
                            <div style={{ display: 'flex', gap: '6px', alignItems: 'center', marginTop: '4px', flexWrap: 'nowrap', overflow: 'hidden' }}>
                              <p style={{ margin: 0, fontWeight: 400, fontSize: '14px', color: '#2A2A2A', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flexShrink: 0, maxWidth: '50%' }}>{result?.SKU || ''}</p>
                              {result?.ID && (
                                <>
                                  <span style={{ color: '#E5E5E5', flexShrink: 0 }}>|</span>
                                  <p style={{ margin: 0, fontWeight: 400, fontSize: '14px', color: '#2A2A2A', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{result?.ID}</p>
                                </>
                              )}
                            </div>
                            <div style={{ display: 'flex', gap: '6px', alignItems: 'center', marginTop: '6px', flexWrap: 'nowrap', overflow: 'hidden' }}>
                              {result?.item_name && <p style={{ margin: 0, fontWeight: 400, fontSize: '13px', color: '#6B7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{result?.item_name}</p>}
                              {result?.item_name && result?.collection_name && <span style={{ color: '#E5E5E5', flexShrink: 0 }}>|</span>}
                              {result?.collection_name && <p style={{ margin: 0, fontWeight: 400, fontSize: '13px', color: '#6B7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{result?.collection_name}</p>}
                              {result?.product_variants_enable && (
                                <>
                                  <span style={{ color: '#E5E5E5', flexShrink: 0 }}>|</span>
                                  {result?.product_variants_enable === '1' && <img src={base_assets + 'images/icons/variant-sm.png'} alt="" style={{ width: '16px', height: '16px', flexShrink: 0 }} />}
                                  {result?.product_variants_enable === '2' && <img src={base_assets + 'images/pro-ring-img.png'} alt="" style={{ width: '16px', height: '16px', flexShrink: 0 }} />}
                                  {result?.product_variants_enable === '3' && <img src={giftimage} alt="" style={{ width: '16px', height: '16px', flexShrink: 0 }} />}
                                </>
                              )}
                              {embeddingActive && hasEmbeddingStatusIcon(result?.embedding_status) && (
                                <>
                                  <span style={{ color: '#E5E5E5', flexShrink: 0 }}>|</span>
                                  <EmbeddingStatusIcon
                                    embeddingStatus={result?.embedding_status}
                                  />
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )) : null}
                  </div>
                )}
                {viewMode === 'table' && (
                <>
                <div className="product-sticky-thead">
                  <div
                    className="product-table-hscroll product-table-hscroll--head"
                    ref={tableHeadScrollRef}
                    onScroll={() => syncProductTableScroll("head")}
                  >
                    <table
                      ref={tableHeadTableRef}
                      className="stripe row-border order-column common-table1 table-striped main-table product-head-table"
                    >
                  <thead>
                    <tr>
                      {newcolumndata?.find(c => c.name === 'check_box')?.status !== false && (
                        <th ref={el => stickyThRefs.current[0] = el} style={{ position: 'sticky', left: stickyLefts[0], zIndex: 3, background: '#fff' }}>
                          <div className="com-check"><input type="checkbox" id="selectAll_product" checked={!!selectAllStatus} onChange={e => setSelectAllStatus(e.target.checked)} /><label htmlFor="selectAll_product" className="com-check-label" /></div>
                        </th>
                      )}
                      {newcolumndata?.find(c => c.name === '#')?.status !== false && (
                        <th ref={el => stickyThRefs.current[1] = el} style={{ position: 'sticky', left: stickyLefts[1], zIndex: 3, background: '#fff' }}>#</th>
                      )}
                      {newcolumndata?.find(c => c.name === 'img.')?.status !== false && (
                        <th ref={el => stickyThRefs.current[2] = el} style={{ position: 'sticky', left: stickyLefts[2], zIndex: 3, background: '#fff' }}>{t("img.")}</th>
                      )}
                      {newcolumndata?.find(c => c.name === 'Product name')?.status !== false && (
                        <th ref={el => stickyThRefs.current[3] = el} style={{ position: 'sticky', left: stickyLefts[3], zIndex: 3, cursor: 'pointer', whiteSpace: 'nowrap', boxShadow: '3px 0 5px -2px rgba(0,0,0,0.15)', background: '#fff' }} onClick={() => handleSort('name')}>
                          {t("Product Name")} {sortIcon('name')}
                        </th>
                      )}
                      {newcolumndata?.find(c => c.name === 'Product ID')?.status !== false && (
                        <th style={{ cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => handleSort('ID')}>
                          {t("Product ID")} {sortIcon('ID')}
                        </th>
                      )}
                      {newcolumndata?.find(c => c.name === 'Type')?.status !== false && <th>{t("Type")}</th>}
                      {newcolumndata?.find(c => c.name === 'SKU')?.status !== false && (
                        <th style={{ cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => handleSort('SKU')}>
                          {t("SKU")} 
                          {/* {sortIcon('SKU')} */}
                          {renderColFilterDropdown("sku", colDropdownRefSKU)}
                        </th>
                      )}
                      {newcolumndata?.find(c => c.name === 'trace')?.status !== false && <th></th>}
                      {embeddingActive && newcolumndata?.find(c => c.name === 'embedding')?.status !== false && (
                        <th title={t("Embedding status")}></th>
                      )}
                      {newcolumndata?.find(c => c.name === 'Item')?.status !== false && (
                        <th style={{ cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => handleSort('item_name')}>
                          {t("Item")} 
                          {/* {sortIcon('item_name')} */}
                          {renderColFilterDropdown("item", colDropdownRefItem)}
                        </th>
                      )}
                      {newcolumndata?.find(c => c.name === 'Collection')?.status !== false && (
                        <th style={{ cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => handleSort('collection_name')}>
                          {t("Collection")} 
                          {/* {sortIcon('collection_name')} */}
                          {renderColFilterDropdown("collection", colDropdownRefCollection)}
                        </th>
                      )}
                      {newcolumndata?.find(c => c.name === 'Variant')?.status !== false && <th>{t("Variant")}</th>}
                      {newcolumndata?.find(c => c.name === 'Reorder Point')?.status !== false && (
                        <th style={{ cursor: 'pointer', whiteSpace: 'nowrap', textAlign: 'right' }} onClick={() => handleSort('ReorderPoints')}>
                          {t("Reorder Point")} {sortIcon('ReorderPoints')}
                        </th>
                      )}
                      {newcolumndata?.find(c => c.name === 'Reorder Quantity')?.status !== false && (
                        <th style={{ cursor: 'pointer', whiteSpace: 'nowrap', textAlign: 'right' }} onClick={() => handleSort('ReorderQuantitys')}>
                          {t("Reorder Qty")} {sortIcon('ReorderQuantitys')}
                        </th>
                      )}
                      {newcolumndata?.find(c => c.name === 'Status')?.status !== false && (
                        <th style={{ cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => handleSort('Status')}>
                          {t("Status")} {sortIcon('Status')}
                        </th>
                      )}
                    </tr>
                  </thead>
                    </table>
                  </div>
                </div>
                <div
                  className="product-table-hscroll product-table-hscroll--body"
                  ref={tableBodyScrollRef}
                  onScroll={() => syncProductTableScroll("body")}
                >
                <table
                  id="product_list"
                  ref={tableBodyTableRef}
                  className="stripe row-border order-column common-table1 table-striped main-table"
                >
                  <tbody>
                    {!isActive && sortedList
                      ? sortedList.map((result, key) => {
                          return (
                            <tr key={key + getSkipNumbers} className="">
                              <td style={{ position: 'sticky', left: stickyLefts[0], background: key % 2 === 0 ? '#fff' : '#f4f4f4', zIndex: 2 }}>
                                <div className="com-check" id="">
                                  <input
                                    className="gisClassTh productList_checkBox"
                                    value={result?._id}
                                    data-id={result?._id}
                                    type="checkbox"
                                    id={"product_" + result?._id}
                                    onClick={deleteIcon}
                                    data-name={result?.name ? result?.name : ""}
                                    data-variant={result?.product_variants_enable}
                                    name="master_product_checkbox"
                                  />
                                  <label htmlFor={"product_" + result?._id} className="com-check-label" />
                                </div>
                              </td>
                              <td style={{ position: 'sticky', left: stickyLefts[1], background: key % 2 === 0 ? '#fff' : '#f4f4f4', zIndex: 2 }}>
                                {parseInt(key + getSkipNumbers + 1)}
                              </td>
                              <td
                                style={{ position: 'sticky', left: stickyLefts[2], background: key % 2 === 0 ? '#fff' : '#f4f4f4', zIndex: 2 }}
                                onClick={() => setImageid(result?._id)}
                                data-bs-toggle="modal"
                                data-bs-target="#ProductViewModal"
                              >
                                <div className="table-pro-img">
                                  <img src={result?.main_image ? result?.main_image : ""} alt="" />
                                </div>
                              </td>
                              <td style={{ position: 'sticky', left: stickyLefts[3], background: key % 2 === 0 ? '#fff' : '#f4f4f4', zIndex: 2, boxShadow: '3px 0 5px -2px rgba(0,0,0,0.15)' }}>
                                <div className="tooltip-area-up">
                                  <div className="truncate-text-subtable">
                                    {result?.name || ""}
                                  </div>
                                  {result?.name && <span className="tooltip-area-up-text text-white">{result?.name}</span>}
                                </div>
                              </td>
                              <td className="fixed-side ">
                                {result?.ID ? result?.ID : ""}
                              </td>

                              <td className="fixed-side yellow-text pro-type-img">
                                {result?.product_variants_enable === "1" ? (
                                  <img
                                    className=""
                                    src={
                                      base_assets +
                                      "images/icons/variant-sm.png"
                                    }
                                    alt=""
                                  />
                                ) : result?.product_variants_enable === "2" ? (
                                  <img
                                    className=""
                                    src={
                                      base_assets + "images/pro-ring-img.png"
                                    }
                                    alt=""
                                  />
                                ) : result?.product_variants_enable === "3" ? (
                                  <img className="" src={giftimage} alt="" />
                                ) : (
                                  ""
                                )}
                              </td>
                              <td className="fixed-side">
                                <Link
                                  className="link-color text-decoration-none"
                                  onClick={() =>
                                    setProductValue(
                                      result?._id,
                                      result?.name,
                                      result?.product_variants_enable,
                                    )
                                  }
                                  state={{
                                    product_value_arr: [
                                      {
                                        product_id: result?._id,
                                        name: result?.name,
                                        varient_type:
                                          result?.product_variants_enable,
                                      },
                                    ],
                                    currentPage: currentPage ? currentPage : 0,
                                  }}
                                  to={
                                    editparmission
                                      ? "/app/product/add-new/" + result?._id
                                      : ""
                                  }
                                >
                                  {result?.SKU ? result?.SKU : ""}
                                </Link>
                              </td>
                              <td>
                                {traceabilityEnabled && result?.traceability_on ? (
                                  <img src={traceabilityicon} alt="trace_on" />
                                ) : (
                                  ""
                                )}
                              </td>
                              {embeddingActive && newcolumndata?.find(c => c.name === 'embedding')?.status !== false && (
                                <td>
                                  <EmbeddingStatusIcon
                                    embeddingStatus={result?.embedding_status}
                                  />
                                </td>
                              )}
                              <td className="fixed-side">
                                {result?.item_name ? result?.item_name : ""}
                              </td>
                              <td className="sku-col">
                                {result?.collection_name
                                  ? result?.collection_name
                                  : ""}
                              </td>
                              <td className="fixed-side">
                                {result?.VariantsCount
                                  ? result?.VariantsCount
                                  : "0"}
                              </td>
                              <td className="fixed-side text-end">
                                {result?.ReorderPoints
                                  ? result?.ReorderPoints
                                  : ""}
                              </td>
                              <td className="fixed-side text-end">
                                {result?.ReorderQuantitys
                                  ? result?.ReorderQuantitys
                                  : "0"}
                              </td>
                              {result?.Status === "Active" ? (
                                <td className="fixed-side link-color text-center">
                                  {t("Active")}
                                </td>
                              ) : (
                                <td className="fixed-side danger-text">
                                  {" "}
                                  {t("Inactive")}
                                </td>
                              )}
                            </tr>
                          );
                        })
                      : ""}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td className="main-green-text left-0">
                        {selecteditem.length > 0 ? (
                          <span>
                            {" "}
                            {selecteditem.length} {t("item selected")}
                          </span>
                        ) : (
                          ""
                        )}
                      </td>
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
                </div>
                </>
                )}
                {isActive && <TableLoader />}
              </div>
            </div>
            {productlist.length > 0 ? (
              <Pagination
                total={totalPages}
                current={currentPage}
                pagination={(crPage) => handlePaginations(crPage)}
              />
            ) : (
              ""
            )}
          </div>
        </div>
        <SocialModal shareUrl={socialurl} shareloader={shareloader} />

        <TableColumnModal
          tablehead={productmaintablehead}
          tblName={"tbl_product_main"}
          setnewcolumndata={setnewcolumndata}
          calldatatable={Getproduct}
        ></TableColumnModal>
      </div>
      <div
        className="modal fade common-modal"
        id="inventoryreverse"
        tabIndex={-1}
        aria-labelledby="inventoryreverseLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <img
                className="common-modal-exclamation-img"
                src={base_assets + "images/icons/exclamation-mark-red.png"}
                alt=""
              />
              <p className="modal-content-text">
                {t(
                  "Are you sure you want to delete selected product from reserve list ?",
                )}
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn modal-content-no"
                data-bs-dismiss="modal"
              >
                {t("No")}
              </button>
              <button type="button" className="btn modal-content-yes-red">
                {t("yes")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <DeleteModal
        statement={t("Product")}
        handler_delete={handler_delete}
      ></DeleteModal>
      <Productfiltermodal
        productfilterdetails={productfilterdetails}
        setCollectionsFilter={setCollectionsFilter}
        setItemsFilter={setItemsFilter}
        setFilterApply={setFilterApply}
      ></Productfiltermodal>
      <ProductSampleFormatModal />
      <ProductImportExportModel
        master_product_checkbox_value={selecteditem}
        setGetProductExportList={setGetProductExportList}
        getProductExportList={getProductExportList}
      ></ProductImportExportModel>
      <ProductImageSliderModal main_id={imageid}></ProductImageSliderModal>
    </React.Fragment>
  );
};

export default MainList;
